<app-dynamic-form title="Admin Agent" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
